import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, LineElement, PointElement } from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);




const lineData = {
  labels: ['1월', '2월', '3월', '4월', '5월'],
  datasets: [
    {
      label: '판매량',
      data: [650000, 590000, 800000, 810000, 560000],
      fill: false,
      borderColor: 'rgb(75, 192, 192)',
      tension: 0.1
    }
  ]
};

const lineOptions = {
  plugins: {
    tooltip: {
      callbacks: {
        // 툴팁에서의 라벨 설정
        label: function(context) {
          let label = context.dataset.label || '';
          if (label) {
            label += ': ';
          }
          label += `${context.parsed.y}`;
          return label;
        }
      }
    }
  }
  // 나머지 옵션들...
};

function LineChart() {
  return <Line data={lineData} options={lineOptions} />;
}

export default LineChart;